import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
// import AddTranslation from "../layout/translation/AddTranslation";

const Translations = lazy(() => import("../layout/translation/Translations"));

const AddTranslation = lazy(
  () => import("../layout/translation/AddTranslation"),
);

function TranslationPage() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback={<div>Loading</div>}>
            <Translations />
          </Suspense>
        }
      />
      <Route
        path="/add"
        element={
          <Suspense fallback={<div>Loading</div>}>
            <AddTranslation />
          </Suspense>
        }
      />
      <Route
        path="/update/:key"
        element={
          <Suspense fallback={<div>Loading</div>}>
            <AddTranslation />
          </Suspense>
        }
      />
    </Routes>
  );
}

export default TranslationPage;
